import React, {Suspense} from "react";
import { Routes, Route, Navigate} from 'react-router-dom';
import { routerConfig } from './routerConfig.js';

// loading页面
const Loading = () => (
    <>
       <div className='loadsvg'> 
          <div>
            loading...
          </div>
       </div> 
    </>
)

// 递归函数
const rotuerViews = (routerItems)=>{
    if(routerItems && routerItems.length){
      return routerItems.map(({path,Component,children,redirect})=>{
          return children && children.length ? (
              <Route path={path} key={path} element={<Suspense fallback={<Loading/>}><Component/></Suspense>}>
                    {rotuerViews(children)}
                    {redirect?
                    (<Route  path={path} element={<Navigate to={redirect} />}></Route>):
                    (<Route path={path} element={<Navigate to={children[0].path} />}></Route>)
                    }
              </Route>
          ):(
            <Route key={path} path={path} element={ <Suspense fallback={<Loading/>}><Component/></Suspense>}>
            </Route>
          )
      })
    }      
}

export const MyRouter = function(){
    return <Routes>
        {rotuerViews(routerConfig)} 
        {/* {routerConfig.map(item => <Route key={item.path} path={item.path} exact={item.exact} element={<item.component />} />)} */}
    </Routes>
}